<template>
  <div class="content-outer">
    <b-container>
      <div class="def-func-form">
        <form @submit.prevent="getReports">
          <div class="def-func-input-form-group mb-0">
            <b-row>
              <b-col sm='6' md='6' lg>
                <div class="def-func-input-group mt-4">
                  <label for="start-date">Start Month/Year</label>
                  <b-form-input 
                    type="month" 
                    v-model="startDate" 
                    id="start-date" 
                    class="month-picker"
                    :min="'2000-01'"
                    :max="'2050-12'"
                  />
                </div>
              </b-col>
              <b-col sm='6' md='6' lg>
                <div class="def-func-input-group mt-4">
                  <label for="end-date">End Month/Year</label>
                  <b-form-input 
                    type="month" 
                    v-model="endDate" 
                    id="end-date" 
                    class="month-picker"
                    :min="startDate || '2000-01'"
                    :max="'2050-12'"
                  />
                </div>
              </b-col>
              <b-col sm='6' md='6' lg>
                <div class="def-func-input-group mt-4">
                  <label for="rootcause">Rootcause</label>
                  <b-form-select v-model="selectedRootcause" :options="rootcauseOptions" id="rootcause" />
                </div>
              </b-col>
              <b-col sm='6' md='6' lg>
                <div class="def-func-input-group mt-4">
                  <label for="status">Status</label>
                  <b-form-select v-model="selectedStatus" :options="statusOptions" id="status" />
                </div>
              </b-col>
              <b-col lg='auto'>
                <div class="def-func-input-form-group mt-4">
                  <div class="w-100 flex-js-end generate-btn-outer">
                    <b-button type="submit" variant="light">
                      Generate Report
                    </b-button>
                  </div>
                </div>
              </b-col>
              <b-col lg='12'>
                <div class="def-func-input-form-group mt-4">
                  <div class="w-100 flex-js-end">
                    <b-button variant="light" @click="downloadPDF">
                      Print Report
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </form>
      </div>
      <div>
        <div ref="content" class="content-box">
          <h1 class="mb-5 report-title text-center">{{chartOptionsbar.series[0].data.length > 0 && chartOptionspie.series[0].data.length > 0 ?
          'Rootcause Report' : ''}}</h1>
          <div class="chart-container mt-4 mb-4" v-if="chartOptionsbar.series[0].data.length">
            <highcharts :options="chartOptionsbar"></highcharts>
          </div>
          <div class="chart-container mt-4" v-if="chartOptionspie.series[0].data.length">
            <highcharts :options="chartOptionspie"></highcharts>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
  import { HTTP_BASE, HTTP_formdata } from "../../../constants/http-common";
  import { EventBus } from "../../../main";
  import Highcharts, { color } from 'highcharts';
  import { genComponent } from 'vue-highcharts';
  import jsPDF from "jspdf";
  import html2canvas  from 'html2canvas';
  import 'jspdf-autotable';
  export default {
    components: {
      Highcharts: genComponent('Highcharts', Highcharts),
    },
    data() {
      return {
        startDate: '',
        endDate: '',
        selectedRootcause: null,
        selectedStatus: null,
        rootcauseOptions: [
          { value: null, text: 'Select Rootcause', disabled: true }
        ],
        statusOptions: [
          { value: null, text: 'Select Status', disabled: true },
          { value: 'open', text: 'Open' },
          { value: 'closed', text: 'Closed' }
        ],
        chartOptionsbar: {
          chart: {
            type: 'bar'
          },
          title: {
            text: 'Root Cause Analysis'
          },
          xAxis: {
            categories: [],
            title: {
              text: 'Root Cause Sub Categories'
            }
          },
          yAxis: {
            title: {
              text: 'Count'
            }
          },
          series: [{
            name: 'Incidents',
            data: []
          }]
        },
        chartOptionspie: {
          chart: {
            type: 'pie',
            height: '400px'
          },
          title: {
            text: 'Root Cause Analysis'
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
            point: {
              valueSuffix: '%'
            }
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y} ({point.percentage:.1f}%)'
              },
              showInLegend: true
            }
          },
          series: [{
            name: 'Incidents',
            colorByPoint: true,
            data: []
          }]
        }
      };
    },
    mounted() {
      this.fetchRootcauses();
    },
    methods: {
      fetchRootcauses() {
        console.log('Fetching rootcauses...');
        HTTP_BASE.get("incident_report_rootcauses")
          .then(response => {
            let rootCauses = response.data['hydra:member'];
            for (var i = 0; i < rootCauses.length; i++) {
              this.rootcauseOptions.push({
                value: rootCauses[i].public_id,
                text: rootCauses[i].category,
                subs: rootCauses[i].subs
              });
            }
          })
          .catch(err => {
            console.error('Error getting incident_report_rootcauses data:', err);
          });
      },

      getLastDayOfMonth(yearMonth) {
        const [year, month] = yearMonth.split('-');
        return new Date(year, month, 0).getDate();
      },
      getReports() {
        this.messsage_loader = true;
        const payload = {
          start_date: this.startDate + '-01',
          end_date: this.endDate + '-' + this.getLastDayOfMonth(this.endDate),
          rootcause: this.selectedRootcause,
          status: this.selectedStatus
        };

        HTTP_formdata.post("incident_reports/rootcause_report", payload)
          .then(response => {
            // Handle success
            let reportsData = response.data.data;
            this.processChartData(reportsData);
            this.messsage_loader = false;
          })
          .catch(error => {
            // Handle error
            this.messsage_loader = false;
            let errorMessage = error.response && error.response.data ? error.response.data.message : 'Error generating report';
            let errorResp = {
              msg: errorMessage,
              popup: true
            };
            EventBus.$emit("error_resp", errorResp);
          });
      },
      processChartData(data) {
        // For Pie Chart - total counts by rootcause_sub (no changes)
        const totalCountsBySub = data.reduce((acc, item) => {
          acc[item.rootcause_sub] = (acc[item.rootcause_sub] || 0) + 1;
          return acc;
        }, {});

        // Update pie chart
        const pieData = Object.entries(totalCountsBySub).map(([name, y]) => ({
          name,
          y
        }));
        this.chartOptionspie.series[0].data = pieData;

        // For Bar Chart - monthly data
        const monthlyData = data.reduce((acc, item) => {
          const date = new Date(item.created_on);
          const monthYear = date.toLocaleString('default', { month: 'short', year: '2-digit' });
          
          if (!acc[monthYear]) {
            acc[monthYear] = {};
          }
          if (!acc[monthYear][item.rootcause_sub]) {
            acc[monthYear][item.rootcause_sub] = 0;
          }
          acc[monthYear][item.rootcause_sub]++;
          return acc;
        }, {});

        // Sort months chronologically
        const months = Object.keys(monthlyData).sort((a, b) => {
          const dateA = new Date(a.replace(' ', ' 20'));
          const dateB = new Date(b.replace(' ', ' 20'));
          return dateA - dateB;
        });

        // Get unique rootcause_sub values
        const uniqueRootCauseSubs = [...new Set(data.map(item => item.rootcause_sub))];

        // Create series data for each rootcause_sub (similar to Boys, Girls in example)
        const barSeries = uniqueRootCauseSubs.map(sub => ({
          name: sub,
          data: months.map(month => monthlyData[month][sub] || 0)
        }));

        // Update bar chart options to match example format
        this.chartOptionsbar = {
          chart: {
            type: 'column'
          },
          title: {
            text: 'Monthly Root Cause Analysis'
          },
          xAxis: {
            categories: months,
            title: {
              text: 'Months'
            }
          },
          yAxis: {
            allowDecimals: false,
            title: {
              text: 'Count'
            },
            min: 0
          },
          legend: {
            enabled: true,
            align: 'right',
            verticalAlign: 'top',
            layout: 'vertical'
          },
          plotOptions: {
            column: {
              grouping: true,
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{y}',
                style: {
                  fontWeight: 'bold',
                  color: 'white'
                },
                verticalAlign: 'top'
              }
            }
          },
          tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y}'
          },
          series: barSeries
        };
      },
      downloadPDF() {
        const content = this.$refs.content;
        html2canvas(content, {
          scrollY: -window.scrollY,
          useCORS: true,
          scale: 2 
        }).then(canvas => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("p", "mm", "a4");
          const margin = 5;
          const imgWidth = 210 - 2 * margin;
          const pageHeight = 297;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;
          let position = margin * 2;

          pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft > 0) {
            position = heightLeft - imgHeight + margin;
            pdf.addPage();
            pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
          pdf.save("Rootcause Report.pdf");
        });
      }
    }
  };
</script>

<style scoped>
@import "../def_function.css";
@import "../dashboard.css";

.dashboard-text {
  color: #333;
  font-size: 22px;
  margin: 5% 0;
  text-align: center;
}

.btn-rename-delete {
  background-color: #003261;
  color: white;
  padding: 8px 20px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.03rem;
}

.btn-rename-delete:hover {
  background-color: #002347;
  color: white;
}

.chart-container {
  min-height: 400px;
  margin-top: 2rem;
  background: white;
  padding: 1rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.month-picker {
  height: 40px;
  border: 1px solid #a9a9a9;
  border-radius: 5px;
  padding: 0 10px;
}

.month-picker:focus {
  border-color: #003261;
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(0, 50, 97, 0.25);
}
.flex-js-end {
  display: flex;
  justify-content: flex-end;
}

.generate-btn-outer {
  margin-top: 50px;
}

.report-title {
  color: #485882;
}
</style>